import isArtworkUrl from './isArtworkUrl';
import isCombinerUrl from './isCombinerUrl';
import isStitcherUrl from './isStitcherUrl';
import canUseCombiner from './canUseCombiner';
import { queryString } from 'lib/format';

// This is the threshold in which we shouldn't request a resized image, but the natural one instead
const NATURAL_THRESHOLD = 1800;

export function toSecureCombinerUrl(url) {
    if (isCombinerUrl(url)) {
        return url.replace('http://a.espncdn.com', 'https://secure.espncdn.com');
    }
    return url;
}

/**
 * Converts an eligible url to a combiner url
 * @param {string} url
 */
export function convertToCombinerUrl(url) {
    if (url && !isCombinerUrl(url) && !isStitcherUrl(url)) {
        return url.replace(/(http:\/\/a\.espncdn\.com|https:\/\/secure\.espncdn\.com)/, 'https://secure.espncdn.com/combiner/i?img=');
    }
    // TODO: remove once page api starts to return secure combiner url
    return toSecureCombinerUrl(url);
}

/**
 * For now, the only params to replace are width and height.  If more params are needed, a more algorithmic
 * approach should be used
 * @param {string} query - Query string
 */
export function convertToCombinerQueryString(query) {
    return query.replace('width=', 'w=').replace('height=', 'h=');
}

/**
 * Removes all sizing dimension parameters from an image
 * @param {string} url
 */
export function removeDimensions(url) {
    if (url && typeof url === 'string') {
        return url.replace(/(?:width|height|[wh])=\d*&?/g, '');
    }
    return url;
}

/**
 * Removes a given parameter from the url
 * @param {string} url
 * @param {string} param
 */
export function removeParam(url = '', param) {
    if (param) {
        const paramRegex = new RegExp(`${param}=[a-zA-Z0-9_]*`, 'g');
        return url.replace(paramRegex, '');
    }
    return url;
}

/**
 * This function will replace/remove dimensions of an image if specified in params.
 * It will also add any other params specified.
 * Note: This will add any parameters that are not height/width dimensions
 * @param {string} urlArg
 * @param {object} params - Supports { width, cquality, height }
 */
export function getImageUrlWithParams(urlArg, paramsArg = {}) {
    if (!isArtworkUrl(urlArg) && !canUseCombiner(urlArg)) {
        return urlArg;
    }
    let url = !isArtworkUrl(urlArg) ? convertToCombinerUrl(urlArg) : urlArg;

    let params = paramsArg;
    const { width, height } = params;

    // if the dimensions are altered, remove all existing dimension params
    if (width || height) {
        url = removeDimensions(url);

        // if the width of the image is larger than a defined threshold, just use the natural image
        if (isCombinerUrl(url) && width >= NATURAL_THRESHOLD) {
            // remove width by destructure and spread
            const { width: omittedWidth, ...cleansedParams } = params;
            params = cleansedParams;
        }
    }

    let qs = queryString(params, false, url.indexOf('?') > -1);
    if (isCombinerUrl(url)) {
        qs = convertToCombinerQueryString(qs);
    }
    return `${url}${qs}`;
}



// WEBPACK FOOTER //
// ./app/lib/url-adapter/index.js